import { Screens } from 'patient-api-lib'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import {
  getSidebarBullets,
  getSidebarImage,
  selectInitialScreen,
  selectMode,
} from '../../features/appConfigSlice'
import { selectCurrentScreen } from '../../features/screensRouterSlice'
import { useAppSelector } from '../../hooks/useAppSelector'
import { SVGIconType, WidgetMode } from '../../models/enums'
import SidebarTextBlock from '../SidebarTextBlock/SidebarTextBlock'
import SVGIcon from '../SVGIcon/SVGIcon'
import { getJumbotronStyleObject } from './helper'
import {
  backButton,
  backButtonIcon,
  backButtonText,
  jumbotronVariants,
} from './SidebarContent.css'

export type SidebarContentProps = {
  onBack: () => void
}

const SidebarContent = (props: SidebarContentProps) => {
  const { onBack } = props
  const sidebarImage = useAppSelector(getSidebarImage)
  const sidebarBullets = useAppSelector(getSidebarBullets)
  const isEmptySidebarBullets = sidebarBullets && sidebarBullets.length === 0
  const mode = useAppSelector(selectMode)
  const initialScreen = useAppSelector(selectInitialScreen)
  const currentScreen = useAppSelector(selectCurrentScreen)
  const { t } = useTranslation('jumbotron')
  const disableOnScreens = useMemo(
    () => [
      initialScreen,
      Screens.BookingConfirmationScreen,
      Screens.YourBookingsScreen,
      Screens.TokenizationScreen,
    ],
    [initialScreen]
  )

  const showEmbeddedBackButton = useMemo(() => {
    return (
      mode === WidgetMode.Embedded &&
      !disableOnScreens.includes(currentScreen as Screens)
    )
  }, [currentScreen, disableOnScreens, mode])

  return (
    <div
      className={mode ? jumbotronVariants[mode] : ''}
      style={getJumbotronStyleObject(sidebarImage, isEmptySidebarBullets)}
    >
      {showEmbeddedBackButton && (
        <button
          className={backButton}
          onClick={onBack}
          data-testid="back-widget-button"
        >
          <SVGIcon icon={SVGIconType.ChevronLeft} className={backButtonIcon} />
          <span className={backButtonText}>{t('back_button')}</span>
        </button>
      )}
      <SidebarTextBlock />
    </div>
  )
}

export default SidebarContent
